import { app } from '../../app';

app.component('spFooter', {
    templateUrl: require('./sp-footer.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-footer/sp-footer.component.js